// extracted by mini-css-extract-plugin
export default {"title":"yo4lA","bordered":"QFroM","leftAlign":"wcwtp"};